import Money from "~/models/Money";
import InvoiceLine from "~/models/read/Checkout/InvoiceLine";

export default class Invoice {
  private readonly _hasDiscount: boolean;
  private readonly _discount: Money;
  private readonly _total: Money;
  private readonly _totalWithoutDiscount: Money;
  private readonly _invoiceLines: Array<InvoiceLine>;
  constructor({
                hasDiscount,
                discount,
                total,
                totalWithoutDiscount,
                invoiceLines
              }) {
    this._hasDiscount = hasDiscount;
    this._discount = discount;
    this._total = total;
    this._totalWithoutDiscount = totalWithoutDiscount;
    this._invoiceLines = invoiceLines ? invoiceLines.map(s => new InvoiceLine(s)) : null;
  }

  get hasDiscount(): boolean {
    return this._hasDiscount;
  }

  get discount(): Money {
    return this._discount;
  }

  get total(): Money {
    return this._total;
  }

  get totalWithoutDiscount(): Money {
    return this._totalWithoutDiscount;
  }

  get invoiceLines(): Array<InvoiceLine> {
    return this._invoiceLines;
  }

}
